<template>
  <div class="inputs-block">
    <div class="row">
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <DateTime v-model="value.date" type="date" placeholder="Date" required />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Select
          v-model="value.team"
          :options="teamsOptions"
          placeholder="Team"
          required
          customID="teams_options"
        />
      </div>
    </div>
    <div @click="visible = !visible" class="collapse-header">
      <BlockHeader name="Shift Staffing">
        <component :is="visible ? 'BIconEyeSlash' : 'BIconEye'"> </component>
      </BlockHeader>
    </div>
    <b-collapse v-model="visible" id="collapse" v-if="value.date && value.team">
      <AddUser
        id="addShiftUser"
        :onSave="addNewUser"
        :selectedEntity="users"
        header="Add Employee"
        :list="usersList"
        entity="Employee"
        v-if="usersList"
      />
      <div v-if="users">
        <div class="row user-line" v-for="user in users" :key="user.id">
          <div class="col-lg-6 col-sm-12 col-xs-12 text-log-line d-flex align-items-center">
            <div class="user-name">
              <span>{{ user.name }}</span> <span class="user-email">({{ user.email }})</span>
            </div>
          </div>
          <div class="col-lg-4 col-sm-12 col-xs-12" v-if="!isNotPresent(user)">
            <Select
              v-model="shiftStaffing[user.id]"
              :viewMode="!isMyTeam"
              :options="shiftPositions"
              placeholder="Shift Position"
              :required="true"
              :customID="`shift_position_${user.id}`"
            />
          </div>
          <div class="col-lg-4 col-sm-12 col-xs-12 input-log-line" v-else>{{ 'Absence' | i18n }}: {{ user.shiftDetails.absence | i18n }}</div>
          <div class="col-lg-2 col-sm-12 col-xs-12 button-log-line mt-4 pt-1">
            <div class="delete-button" @click="deleteUser(user)" v-if="isMyTeam">
              {{ 'Delete' | i18n }}
            </div>
          </div>
        </div>
      </div>
      <Loader v-else />
      <b-button variant="outline-primary" size="sm" v-if="isMyTeam" v-b-modal.addShiftUser>
        {{ 'Add Employee' | i18n }}
      </b-button>
    </b-collapse>
  </div>
</template>

<script>
import { BIconEye, BIconEyeSlash } from 'bootstrap-vue';

import BlockHeader from '../../../../common/block-header';
import DateTime from '../../../../common/date-time';
import Select from '../../../../common/select';
import Loader from '../../../../common/loader';
import { DeleteRowMixin } from '../../../../../../mixins';
import { ABSENCE_TYPES, ABSENCE_IS_NOT_PRESENT } from '../../../../../../../../../constants';
import AddUser from './add-entity';
import api from '../../../../../api';
export default {
  title: 'Shift Staff',
  components: { BlockHeader, DateTime, Select, Loader, AddUser, BIconEye, BIconEyeSlash },
  mixins: [DeleteRowMixin],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    teamsOptions: {
      type: Array,
      default: () => [],
    },
    shiftPositions: {
      type: Array,
      default: () => [],
    },
    shiftStaffing: {
      type: Object,
      default: () => {},
    },
    updateUsers: {
      type: Function,
      default: () => {},
    },
    isMyTeam: {
      type: Boolean,
      default: false,
    },
    users: {
      type: Array,
    },
  },
  data() {
    return {
      usersList: [],
      visible: true,
    };
  },
  async created() {
    const users = await api.teams.getUsersLookup();
    this.usersList = users.data;
  },
  methods: {
    isNotPresent(u) {
      if (u && u.shiftDetails && u.shiftDetails.absence) {
        const a = u.shiftDetails.absence;
        if (ABSENCE_IS_NOT_PRESENT.includes(a)) {
          return true;
        }
      }
      return false;
    },
    addNewUser(user) {
      const newUsers = [...this.users];
      newUsers.push({
        name: user.username,
        email: user.email,
        id: user.id,
      });
      this.updateUsers(newUsers);
    },
    async deleteUser(user) {
      await this.deleteSelectedRows(null, () => {
        const newUsers = [...this.users];
        this.updateUsers(newUsers.filter((u) => u.id !== user.id));
      });
    },
  },
};
</script>

<style scoped lang="scss">
.height100 {
  height: 100%;
}
.inputs-block {
  margin-bottom: 50px;
}

.user-name {
  font-size: 20px;
}
.user-email {
  font-size: 14px;
  color: #c7c7c7;
}

.user-line {
  padding: 10px 0;
  margin: 10px 0;
  box-shadow: 0px 0px 8px 0px rgba(34, 60, 80, 0.2);
  .form-group {
    margin-bottom: 0px;
  }
}

.delete-button {
  background: rgb(219, 71, 79);
  color: white;
  border-color: #db474f;
  border: 2px solid #db474f;
  border-radius: 4px;
  padding: 8px 13px;
  margin: 0px 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.collapse-header {
  user-select: none;
  cursor: pointer;
}
</style>
